import React, { useState, useEffect, useRef } from 'react'
import styles from './MyDocsTab.module.scss'
import DocTable from '../../components/DocTable/DocTable'
import SearchBar from '../../components/SearchBar/SearchBar'
import {
  getMyDocuments, uploadDocument, deleteDocument,
  downloadDocument, toggleDocumentFlag,
} from 'service/KomurConnectionService'
import { fmtSize, fileIcon, filterDocs } from '../../utils'

export default function MyDocsTab({ onPreview }) {
  const [docs,          setDocs]          = useState(null)
  const [uploading,     setUploading]     = useState(false)
  const [uploadPending, setUploadPending] = useState(null)
  const [search,        setSearch]        = useState('')
  const fileInputRef = useRef()

  useEffect(() => {
    getMyDocuments()
      .then(r => setDocs(r.data))
      .catch(() => setDocs([]))
  }, [])

  const handleFileSelect = (e) => {
    const file = e.target.files?.[0]
    if (!file) return
    setUploadPending({ file, title: file.name.replace(/\.[^/.]+$/, ''), desc: '' })
    fileInputRef.current.value = ''
  }

  const handleUploadConfirm = async () => {
    const { file, title, desc } = uploadPending
    if (!title.trim()) return
    const fd = new FormData()
    fd.append('file', file)
    fd.append('title', title.trim())
    if (desc.trim()) fd.append('description', desc.trim())
    setUploading(true)
    try {
      const r = await uploadDocument(fd)
      setDocs(prev => [r.data, ...(prev || [])])
      setUploadPending(null)
    } catch {}
    setUploading(false)
  }

  const handleToggle = (docId, flag) => {
    toggleDocumentFlag(docId, flag)
      .then(r => setDocs(prev => prev.map(d => d.id === docId ? { ...d, ...r.data } : d)))
      .catch(() => {})
  }

  const handleDelete = (docId) => {
    if (!window.confirm('Удалить документ?')) return
    deleteDocument(docId)
      .then(() => setDocs(prev => prev.filter(d => d.id !== docId)))
      .catch(() => {})
  }

  const handleDownload = (_docType, id, fileName) => {
    downloadDocument(id).then(r => {
      const a = document.createElement('a')
      a.href = r.data.file_url
      a.download = fileName || 'document'
      a.click()
    }).catch(() => {})
  }

  return (
    <div className={styles.section}>
      <div className={styles.header}>
        <h3 className={styles.title}>Мои документы</h3>
        {!uploadPending && (
          <button
            className={styles.uploadBtn}
            onClick={() => fileInputRef.current?.click()}
            disabled={uploading}
          >
            {uploading ? 'Загрузка…' : '+ Загрузить файл'}
          </button>
        )}
        <input ref={fileInputRef} type="file" style={{ display: 'none' }} onChange={handleFileSelect} />
      </div>

      {uploadPending && (
        <div className={styles.form}>
          <div className={styles.formFile}>
            <span>{fileIcon(uploadPending.file.name.split('.').pop())}</span>
            <span className={styles.formFilename}>{uploadPending.file.name}</span>
            <span className={styles.formSize}>{fmtSize(uploadPending.file.size)}</span>
          </div>
          <div className={styles.formFields}>
            <div className={styles.formField}>
              <label className={styles.formLabel}>Название документа</label>
              <input
                className={styles.formInput}
                value={uploadPending.title}
                onChange={e => setUploadPending(p => ({ ...p, title: e.target.value }))}
                placeholder="Название документа"
                autoFocus
              />
            </div>
            <div className={styles.formField}>
              <label className={styles.formLabel}>
                Описание <span className={styles.formOptional}>(необязательно)</span>
              </label>
              <input
                className={styles.formInput}
                value={uploadPending.desc}
                onChange={e => setUploadPending(p => ({ ...p, desc: e.target.value }))}
                placeholder="Краткое описание…"
              />
            </div>
          </div>
          <div className={styles.formActions}>
            <button
              className={styles.confirmBtn}
              onClick={handleUploadConfirm}
              disabled={uploading || !uploadPending.title.trim()}
            >
              {uploading ? '⏳ Загрузка…' : '✓ Загрузить'}
            </button>
            <button
              className={styles.cancelBtn}
              onClick={() => setUploadPending(null)}
              disabled={uploading}
            >
              Отмена
            </button>
          </div>
        </div>
      )}

      <SearchBar value={search} onChange={setSearch} placeholder="Поиск по документам…" />
      <DocTable
        docs={filterDocs(docs, search)}
        showFlags
        onToggle={handleToggle}
        onDelete={handleDelete}
        onDownload={handleDownload}
        onPreview={onPreview}
      />
    </div>
  )
}
